export default __webpack_public_path__ + "static/us-map-midwest-861365b8ca595bd81d3d2f0e9e140d86.svg";